<template>
  <div class="flex gap-[10px] flex-col">
    <TagInputWithDropdownList
      ref="includeDropdown"
      :label="t('appliedFilters.include')"
      :empty-label="t('appliedFilters.searchForAMediaList')"
      :translate-label="false"
      :tooltip-text="t('appliedFilters.mediaListIncludeTooltip')"
      :list="mediaListStore.mediaListDropdownItems"
      :selected-tags="mediaListStore.includedMediaLists"
      :data-text="'includeDropdown'"
      @add="mediaListStore.addIncludedMediaList"
      @remove="mediaListStore.removeIncludedMediaList"
    />
    <TagInputWithDropdownList
      ref="excludeDropdown"
      :label="t('appliedFilters.exclude')"
      :empty-label="t('appliedFilters.searchForAMediaList')"
      :translate-label="false"
      :tooltip-text="t('appliedFilters.mediaListExcludeTooltip')"
      :list="mediaListStore.mediaListDropdownItems"
      :selected-tags="mediaListStore.excludedMediaLists"
      :data-text="'excludeDropdown'"
      @add="mediaListStore.addExcludedMediaList"
      @remove="mediaListStore.removeExcludedMediaList"
    />
  </div>
</template>

<script setup lang="ts">
import { useNuxtApp } from "nuxt/app";
import { ref, Ref, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import TagInputWithDropdownList from "~/components/shared/TagInputWithDropdownList.vue";
import { useMediaListStore } from "~/store/mediaList";
import Emitter from "~/types/Emitter";

const { t } = useI18n();

const { $bus }: Emitter = useNuxtApp();
const includeDropdown: Ref = ref(null);
const excludeDropdown: Ref = ref(null);

$bus.$on("CustomDrawer:click", (e: Array<any>) => {
  if (e[1]) {
    includeDropdown.value?.collapse();
    excludeDropdown.value?.collapse();
    return;
  }
  if (
    ![includeDropdown, excludeDropdown].some((r) =>
      r.value?.$el.contains(e[0].target),
    )
  ) {
    includeDropdown.value?.collapse();
    excludeDropdown.value?.collapse();
  }
});

const mediaListStore = useMediaListStore();

onBeforeUnmount(() => {
  $bus.$off("CustomDrawer:click");
});
</script>
